import React, { useEffect, useState } from 'react';

interface Props {
    lista: any[];
    onSelect: (value: number) => void;
    defaultValue?: number;
}

export const TabPills = ({ lista, onSelect, defaultValue }: Props) => {
    const initialVal = defaultValue ?? lista?.[0]?.valor ?? 0;
    const [selectedValue, setSelectedValue] = useState<number>(initialVal);

    useEffect(() => {
        const initialValue = defaultValue ?? lista?.[0]?.valor ?? 0;
        setSelectedValue(initialValue);
        onSelect(initialValue);
    }, [lista, defaultValue]);

    const handleItemChange = (value: number) => {
        setSelectedValue(value);
        onSelect(value);
    };

    return (
        <div className="btn-group" role="group">
            {lista.map((item: any) => (
                <React.Fragment key={item.valor}>
                    <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id={`btnradio${item.label}`}
                        autoComplete="off"
                        value={item.valor}
                        checked={selectedValue === item.valor}
                        onChange={() => handleItemChange(item.valor)}
                    />
                    <label className="btn btn-outline-primary" htmlFor={`btnradio${item.label}`}>
                        {item.valor}
                    </label>
                </React.Fragment>
            ))}
        </div>
    );
};
